"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MODE_EDIT = exports.MODE_ADD = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formik = require("formik");

var _client = require("@peracto/client");

var _peractoHooks = require("@peracto/peracto-hooks");

var _async = _interopRequireDefault(require("react-select/async"));

var _debouncePromise = _interopRequireDefault(require("debounce-promise"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faChevronLeft = require("@fortawesome/pro-regular-svg-icons/faChevronLeft");

var _faTimesCircle = require("@fortawesome/pro-regular-svg-icons/faTimesCircle");

var _faPlusCircle = require("@fortawesome/pro-regular-svg-icons/faPlusCircle");

var _peractoUi = require("@peracto/peracto-ui");

var _SearchEnginePreview = _interopRequireDefault(require("./SearchEnginePreview"));

var _ArticleAssignment = _interopRequireDefault(require("./ArticleAssignment"));

var _excluded = ["mode", "values"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var MODE_ADD = 'add';
exports.MODE_ADD = MODE_ADD;
var MODE_EDIT = 'edit';
exports.MODE_EDIT = MODE_EDIT;

var getError = function getError(form, field, label) {
  var error = (0, _formik.getIn)(form.errors, field.name);

  if (error) {
    error = error.replace(field.name, label);
  }

  return error;
};

var ArticleCategoryForm = function ArticleCategoryForm(_ref) {
  var _p_values$sub_urls;

  var _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? MODE_EDIT : _ref$mode,
      values = _ref.values,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useClient = (0, _client.useClient)(),
      client = _useClient.client;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showSEOForm = _useState2[0],
      setShowSEOForm = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      articleAssignment = _useState4[0],
      setArticleAssignment = _useState4[1];

  var _useSettings = (0, _peractoHooks.useSettings)(),
      p_values = _useSettings.values;

  var articleCategoryPath = (p_values === null || p_values === void 0 ? void 0 : (_p_values$sub_urls = p_values.sub_urls) === null || _p_values$sub_urls === void 0 ? void 0 : _p_values$sub_urls.sitemap_article_categories_sub_url) || 'articles';

  var fetchArticleCategories = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(inputValue) {
      var _yield$client, data, fieldValues, id;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return client(_client.GET_LIST, 'article-categories', {
                id: 'article-categories',
                filter: {
                  name: inputValue
                }
              });

            case 2:
              _yield$client = _context.sent;
              data = _yield$client.data;
              fieldValues = data;

              if (mode === MODE_EDIT) {
                id = values.id;
                fieldValues = fieldValues.filter(function (articleCat) {
                  return articleCat.id !== id;
                }); // Don't show the current Article Category in the list
              }

              return _context.abrupt("return", fieldValues.map(function (articleCat) {
                return {
                  label: articleCat.name,
                  value: articleCat.id
                };
              }));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchArticleCategories(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var debouncedFetchArticleCategories = (0, _debouncePromise["default"])(fetchArticleCategories, 200);

  if (articleAssignment) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_peractoUi.FormActions, null, /*#__PURE__*/_react["default"].createElement("a", {
      onClick: function onClick() {
        return setArticleAssignment(false);
      },
      "data-testid": "back-to-article-category"
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faChevronLeft.faChevronLeft,
      className: "mr-2"
    }), "Back to Article Category")), /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "manage-articles-section"
    }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Group, {
      key: "manage-articles",
      id: "manage-articles",
      name: "Manage Articles"
    }, /*#__PURE__*/_react["default"].createElement(_ArticleAssignment["default"], {
      articleCategory: values
    }))));
  }

  return /*#__PURE__*/_react["default"].createElement(_peractoUi.Form, _extends({
    autoComplete: "off",
    values: _objectSpread({
      name: '',
      title: '',
      path: '',
      metaDescription: ''
    }, values),
    onReset: function onReset() {
      setShowSEOForm(false);
    }
  }, props), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "core-section"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Group, {
    key: "core-data",
    id: "core-data",
    name: "Core Data"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
    name: "name",
    testId: "category-name",
    label: "Category Name",
    help: "Most typically used for admin only.",
    required: true
  }), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "title"
  }, function (_ref3) {
    var field = _ref3.field,
        form = _ref3.form;
    return /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
      name: field.name,
      testId: "title",
      label: "Title",
      required: true,
      onBlur: function onBlur() {
        var _field$value;

        if ((field === null || field === void 0 ? void 0 : (_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value.length) > 0) {
          if (!form.values.path || form.values.path.length === 0) {
            form.setFieldValue('path', encodeURI("".concat(field.value.split(' ').join('-').replace(/[`~!@#$£€%^&*_|+=?;:'",.()<>\{\}\[\]\\\/]/gi, '').replace(/-+/g, '-').toLowerCase())));
          }
        }
      }
    });
  }), /*#__PURE__*/_react["default"].createElement(_peractoUi.Textarea, {
    name: "shortDescription",
    testId: "description",
    label: "Short Description",
    help: "Available to be displayed on the Article Category template"
  }), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "parent"
  }, function (_ref4) {
    var field = _ref4.field,
        form = _ref4.form;
    var label = 'Parent Category';
    var error = getError(form, field, label);
    var value = {
      label: 'None',
      value: null
    };

    if (field.value) {
      if (field.value.name) {
        value = {
          label: field.value.name,
          value: field.value
        };
      } else {
        value = field.value;
      }
    }

    return /*#__PURE__*/_react["default"].createElement(_peractoUi.FormGroup, {
      name: field.name,
      label: label,
      help: "Create a hierachy of categories by selecting a parent",
      error: error
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "form-row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-12 col-md-10",
      "data-testid": "parent-category-dropdown"
    }, /*#__PURE__*/_react["default"].createElement(_async["default"], {
      className: "w-100",
      classNamePrefix: "list",
      loadOptions: function loadOptions(input) {
        return debouncedFetchArticleCategories(input, field.value);
      },
      isSearchable: true,
      defaultOptions: value,
      onChange: function onChange(option) {
        form.setFieldValue(field.name, option);
      },
      value: value,
      placeholder: "Search for Attributes to add...",
      noOptionsMessage: function noOptionsMessage(_ref5) {
        var inputValue = _ref5.inputValue;

        if (inputValue.length > 0) {
          return "No results found for '".concat(inputValue, "'.");
        } else {
          return 'Enter text to begin searching.';
        }
      }
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-12 col-md-2 text-right"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      "data-testid": "clear-parent-category",
      className: "btn btn-link px-0",
      onClick: function onClick(e) {
        e.preventDefault();
        form.setFieldValue(field.name, null);
      },
      disabled: !field.value
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faTimesCircle.faTimesCircle,
      className: "mr-2"
    }), "Clear"))));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "seo-section"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Group, {
    key: "search-engine-preview",
    id: "search-engine-preview",
    name: "Search Engine Listing Preview"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex justify-content-end"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-link px-0",
    onClick: function onClick() {
      return setShowSEOForm(!showSEOForm);
    },
    "data-testid": "edit-close-seo-toggle"
  }, showSEOForm ? 'Close' : 'Edit')), showSEOForm ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "path"
  }, function (_ref6) {
    var field = _ref6.field,
        form = _ref6.form;
    return /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
      name: field.name,
      label: "URL & Path",
      prefix: "".concat(process.env.REACT_APP_STOREFRONT_URL || window.location.origin, "/").concat(articleCategoryPath, "/"),
      onBlur: function onBlur() {
        var _field$value2;

        if (((_field$value2 = field.value) === null || _field$value2 === void 0 ? void 0 : _field$value2.length) > 0) {
          var slug = encodeURI(field.value.split(' ').join('-').replace(/-+/g, '-').toLowerCase());
          form.setFieldValue(field.name, slug);
        }
      },
      testId: "seo-slug"
    });
  }), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "metaDescription"
  }, function (_ref7) {
    var _field$value3;

    var field = _ref7.field;
    return /*#__PURE__*/_react["default"].createElement(_peractoUi.Textarea, {
      name: field.name,
      label: "Search Engine Description",
      charactercount: (field === null || field === void 0 ? void 0 : (_field$value3 = field.value) === null || _field$value3 === void 0 ? void 0 : _field$value3.length) || 0,
      testId: "seo-description"
    });
  })) : /*#__PURE__*/_react["default"].createElement(_SearchEnginePreview["default"], {
    path: articleCategoryPath
  }))), mode === MODE_EDIT && /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "manage-articles-section"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Group, {
    key: "manage-articles",
    id: "manage-articles",
    name: "Manage Articles"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    "data-testid": "add-remove-text"
  }, "Add or remove existing articles from this category."), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-primary",
    onClick: function onClick() {
      return setArticleAssignment(true);
    },
    "data-testid": "manage-articles-button"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faPlusCircle.faPlusCircle,
    className: "mr-2"
  }), "Manage Articles"))));
};

ArticleCategoryForm.displayName = 'ArticleCategoryForm';
ArticleCategoryForm.propTypes = {
  values: _propTypes["default"].object,
  mode: _propTypes["default"].oneOf([MODE_ADD, MODE_EDIT]),
  schema: _propTypes["default"].object.isRequired,
  onSubmit: _propTypes["default"].func.isRequired
};
var _default = ArticleCategoryForm;
exports["default"] = _default;